const BillingInvoicePayment = ({
    accountId = '',
    id = '',
    invoiceId = '',
    invoiceNumber = '',
    effectiveDate = '',
    status = '',
    paymentNumber = '',
    type = '',
    amount = '',
    appliedPaymentAmount = '',
    email = '',
    paymentType = '',
    brand = '',
    maskNumber = '',
} = {}) => ({
    accountId: String(accountId),
    id: String(id),
    invoiceId: String(invoiceId),
    invoiceNumber: String(invoiceNumber),
    effectiveDate: String(effectiveDate),
    status: String(status),
    paymentNumber: String(paymentNumber),
    type: String(type),
    amount: String(amount),
    appliedPaymentAmount: String(appliedPaymentAmount),
    email: String(email),
    paymentType: String(paymentType),
    brand: String(brand),
    maskNumber: String(maskNumber),
});

export default BillingInvoicePayment;
